import { CustomYesNoJobQualification } from "common/models";
import * as React from "react";

interface CustomYesNoJobQualificationListProps {
    customYesNoJobQualifications: CustomYesNoJobQualification[]
} 

export const CustomYesNoJobQualificationList: React.FC<CustomYesNoJobQualificationListProps> = (props: CustomYesNoJobQualificationListProps) => {
    const { customYesNoJobQualifications} = props;

        const getCustomQualificationText = (
            customYesNoJobQualification: CustomYesNoJobQualification
        ) => {
            return (
                <>
                    {customYesNoJobQualification.custom_qualification_text}
                </>                    
            );
        };


    return (
        <>
            {customYesNoJobQualifications.map(customYesNoJobQualification => (
                <li style={{ padding: 0 }} key={`${customYesNoJobQualification.job_qualification_id}`}>
                {getCustomQualificationText(customYesNoJobQualification)}
                </li>
            ))}
        </>
    );
};


export default CustomYesNoJobQualificationList;
